// eslint-disable-next-line import/no-extraneous-dependencies
import { get } from 'lodash';
import { Controller, useFormState } from 'react-hook-form';
import {
  Checkbox as MuiCheckbox,
  FormControlLabel,
  FormGroup,
  Stack,
  Typography as TypographyMUI,
} from 'src/components/mui';

import { TCheckboxProps } from './types';
import { FC } from 'react';

type TypographyProps = {
  children?: any;
  sx?: any;
  variant?: any;
  color?: any;
  paddingLeft?: any;
  marginTop?: any;
};

const Typography: FC<TypographyProps> = ({ children, ...props }) => (
  <TypographyMUI {...props}>{children}</TypographyMUI>
);

export const Checkbox = ({
  name,
  rtl,
  label,
  stopPropagation,
  overflowWrap,
  ...other
}: TCheckboxProps) => {
  const { errors } = useFormState();
  const errorMessage = get(errors, `${name}.message`);
  return (
    <Stack>
      <Controller
        name={name}
        render={({ field: { ref, value, ...rest } }) =>
          label ? (
            <FormGroup>
              <FormControlLabel
                sx={{ ml: rtl ? 0 : 1, mr: rtl ? 1 : 0, overflowWrap, color: '#fff' }}
                control={
                  <MuiCheckbox
                    {...rest}
                    checked={value}
                    onClick={(e) => (stopPropagation ? e.stopPropagation() : {})}
                    onMouseDown={(e) => (stopPropagation ? e.stopPropagation() : {})}
                    {...other}
                    inputRef={ref}
                  />
                }
                label={label}
              />
            </FormGroup>
          ) : (
            <MuiCheckbox
              {...rest}
              checked={value}
              onClick={(e) => (stopPropagation ? e.stopPropagation() : {})}
              onMouseDown={(e) => (stopPropagation ? e.stopPropagation() : {})}
              {...other}
              inputRef={ref}
            />
          )
        }
      />
      {errorMessage && (
        <Typography
          variant="caption"
          color="error"
          paddingLeft={1}
          marginTop={0.5}
          sx={{
            display: 'block',
            textAlign: rtl ? 'right' : 'left',
          }}
        >
          {errorMessage}
        </Typography>
      )}
    </Stack>
  );
};
